export function calculateEarlyInvoiceProration(monthlyAmount, startDate, endDate) {
  const monthly = Number(monthlyAmount || 0);
  const start = String(startDate || '');
  const end = String(endDate || '');
  if (!Number.isFinite(monthly) || monthly <= 0) return { valid: false, reason: 'Monthly plan price is unavailable.' };
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || !/^\d{4}-\d{2}-\d{2}$/.test(end)) return { valid: false, reason: 'Coverage dates are required.' };
  const from = new Date(`${start}T00:00:00Z`);
  const to = new Date(`${end}T00:00:00Z`);
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime()) || to < from) return { valid: false, reason: 'End date must be on or after start date.' };
  const coveredDays = Math.floor((to.getTime() - from.getTime()) / 86400000) + 1;
  const daysInStartMonth = new Date(Date.UTC(from.getUTCFullYear(), from.getUTCMonth() + 1, 0)).getUTCDate();
  const dailyRate = monthly / daysInStartMonth;
  const amount = Math.round((monthly * coveredDays / daysInStartMonth + Number.EPSILON) * 100) / 100;
  return {
    valid: true,
    monthlyAmount: monthly,
    coveredDays,
    daysInStartMonth,
    dailyRate,
    amount,
    policy: `Monthly price ÷ ${daysInStartMonth} calendar days × ${coveredDays} covered days`,
  };
}

export function formatMmkAmount(value) {
  const numeric = Number(value || 0);
  if (!Number.isFinite(numeric)) return '—';
  return Number.isInteger(numeric)
    ? numeric.toLocaleString('en-US')
    : numeric.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
